import { render, staticRenderFns } from "./DatatableBulks.vue?vue&type=template&id=6c518a66&"
import script from "./DatatableBulks.vue?vue&type=script&lang=js&"
export * from "./DatatableBulks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports